
import Vue from "vue"
import throttle from "lodash/throttle"
import { getSessionDurationSec } from "@/utils/_"
import type { Track, Session } from "@/types/api/program"

export default Vue.extend({
  props: {
    tracks: { type: Array as VuePropType<Track[]>, required: true },
    sessions: { type: Array as VuePropType<Session[]>, required: true },
  },

  data: () => ({
    magick: 160,
    itemHeight: 67,
    tracksWidth: 0,
  }),

  computed: {
    tracks_ () {
      const { sessions } = this
      return this.tracks.map(t => ({
        ...t,
        sessions: sessions.filter(s => s.track.id === t.id),
      }))
    },

    pxPerSec (): number {
      const minDuration =
        Math.min(...this.sessions.map(getSessionDurationSec).filter(d => d > 0))
      return this.magick / minDuration
    },

    timeline (): { interval: number, dayStart: number, dayDuration: number, items: number[] } {
      const times = this.sessions.flatMap(s => [s.start, s.finish])
      const dayStart = Math.min(...times)
      const dayEnd = Math.max(...times)
      const dayDuration = dayEnd - dayStart
      const interval = 3600 // dayDuration / 12
      const intervalMs = interval * 1000
      const items = []
      for (let i = dayStart; i <= dayEnd; i += intervalMs) items.push(i)
      return { interval, dayStart, dayDuration, items }
    },
  },

  async mounted () {
    await this.$nextTick() // ~
    // this.scrollToNow()

    const { onResize } = this
    onResize()
    window.addEventListener("resize", onResize, { passive: true })
  },

  beforeDestroy () {
    window.removeEventListener("resize", this.onResize)
  },

  methods: {
  //   scrollToNow () {
  //     const now = new Date().getTime()
  //     const timeline = this.timeline.items
  //     for (const [i, t] of timeline.entries()) {
  //       if (now < t) continue
  //       const next = timeline[i + 1]
  //       if (next && now < next)
  //         this.$refs[t]?.[0]?.scrollIntoView({ behavior: "smooth" })
  //     }
  //   },

    onResize: throttle(function (this: any) {
      const tracksEl = this.$refs.tracks as Element
      if (!tracksEl) return
      this.tracksWidth = tracksEl.getBoundingClientRect().width - 130
    }, 100),
  },
})
